import http from '@/service'
import config from '@/config';
import router from "@/router";
import { swal } from '@/alert';
import {
    log
} from '@/logging';

export default {
    async getPaymentMethods(customerIdentificationNumber) {
        log.debug('Getting payment methods information');
        const response = await http.get(config.endpoints.paymentMethodsAWS+ "?customerIdentificationNumber=" + customerIdentificationNumber);
        log.debug('Getting payment methods information obtained: [data="', response.data, '"]');
        log.debug(response);
        if (response.data.status === 200 && response.data.data !== undefined) {
            return response.data.data;
        } else {
            swal({
                type: 'error',
                title: 'Encontramos un error',
                text: 'Por favor intenta más tarde',
                confirmButtonText: 'Volver al inicio',
                animation: false,
                footer: 'Mensaje técnico: ' + response.data.message + ' código: ' + response.data.code
            }).then((result) => {
                if (result.value) {
                    router.app.$router.push({
                        path: "/" // TODO: url correcta
                    });
                }
            });
        }
    },
    async validateOffers(parameters) {
        log.debug('validateOffers', parameters);
        let url = config.endpoints.validateOffers + "?rut=" + parameters.rut + "&canal=" + parameters.canal + "&modulo=" + parameters.modulo
        const response = await http.get(url);
        log.debug('validateOffers: [data="', response.data, '"]');
        log.debug(response);
        if (response.status === 200 && response.data !== undefined) {
            return response.data;
        } else {
            return null;
        }
    },
    async getFeatures(parameters) {
        log.debug('getFeatures', parameters);
        log.debug('config.endpoints.getFeatures', config.endpoints.getFeatures);
        let url = config.endpoints.getFeatures + "?rut=" + parameters.rut
        log.debug('url', url);
        const response = await http.get(url);
        log.debug('getFeatures: [data="', response.data, '"]');
        log.debug(response);
        if (response.status === 200 && response.data !== undefined) {
            return response.data;
        } else {
            return null;
        }
    },
    async initTransaction(customerIdentificationNumber, notificationEmail, paymentType, paymentMethod, paymentChannel, accountList) {
        const params = {
            customerIdentificationNumber: customerIdentificationNumber,
            notificationEmail: notificationEmail,
            paymentType: paymentType,
            paymentMethod: paymentMethod,
            paymentChannel: paymentChannel,
            billingAccountPayables: accountList
        };
        const response = await http.post(config.endpoints.initTransaction, params);
        if (response.data.status === 200 && response.data.data !== undefined) {
            let resp = response.data.data;
            resp.paymentMethod = paymentMethod;
            return resp;
        } else {
            swal({
                type: 'error',
                title: 'Encontramos un error',
                text: 'Por favor intenta más tarde',
                confirmButtonText: 'Volver al inicio',
                animation: false,
                footer: 'Mensaje técnico: ' + response.data.message + ' código: ' + response.data.code
            }).then((result) => {
                if (result.value) {
                    router.app.$router.push({
                        path: "/" // TODO: url correcta
                    });
                }
            });
        }
    },
    async getInvoice(transaction) {
        log.debug('Getting invoice');
        const response = await http.get(config.endpoints.invoice + "/" + transaction);
        log.debug('Getting invoice: [data="', response.data, '"]');
        if (response.data.status === 200 && response.data.data !== undefined) {
            return response.data.data;
        } else {
            swal({
                type: 'error',
                title: 'Encontramos un error',
                text: 'Por favor intenta más tarde',
                confirmButtonText: 'Volver al inicio',
                animation: false,
                footer: 'Mensaje técnico: ' + response.data.message + ' código: ' + response.data.code
            }).then((result) => {
                if (result.value) {
                    router.app.$router.push({
                        path: "/" // TODO: url correcta
                    });
                }
            });
        }
    },
    async getErrorVoucher(transaction) {
        log.debug('Getting error voucher');
        const response = await http.get(config.endpoints.errorVoucher + "/" + transaction);
        log.debug('Getting voucher: [data="', response.data, '"]');
        // Anulacion de pago
        if (response.data.messages.Error[0][0].substr(0, 2) != "id") {
            return response.data.data;
        }
        if (response.data.status === 200 && response.data.data !== undefined) {
            return response.data.data;
        } else {
            swal({
                type: 'error',
                title: 'Encontramos un error',
                text: 'Por favor intenta más tarde',
                confirmButtonText: 'Volver al inicio',
                animation: false,
                footer: 'Mensaje técnico: ' + response.data.message + ' código: ' + response.data.code
            }).then((result) => {
                if (result.value) {
                    router.app.$router.push({
                        path: "/" // TODO: url correcta
                    });
                }
            });
        }

    },

    async sendInvoiceEmail(transaction, email) {
        log.debug('Getting sendInvoiceEmail');
        try {
            email = encodeURIComponent(email);
            const response = await http.get(config.endpoints.sendInvoiceEmail + "/" + transaction + "/" + email + "/");
            if (response.data.status === 200 && response.data.data !== undefined) {
                log.debug('Getting sendInvoiceEmail: [data="', response.data, '"]');
                return response.data.data;
            } else {
                log.error('Error sendInvoiceEmail: [response="', response, '"]');
                return null;
            }
        } catch (e) {
            log.error('Error sendInvoiceEmail: [catch="', e, '"]');
            return null;
        }

    },
}